import { Button, Form, Input } from "antd"
import { WrappedFormUtils } from "antd/lib/form/Form"
import * as React from "react"
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons"

type Props = {
    form: WrappedFormUtils
    isProcessing: boolean
    loginError: boolean
    onSubmit: (email: string, password: string) => void
}

interface PasswordState {
    isVisible: boolean
}

class LoginForm extends React.Component<Props, PasswordState> {
    state: PasswordState = {
        isVisible: false,
    }

    componentDidUpdate(prevProps: Props) {
        if (!prevProps.loginError && this.props.loginError) {
            this.props.form.setFields({
                email: {
                    value: this.props.form.getFieldValue("email"),
                    errors: [
                        {
                            field: "email",
                        },
                    ],
                },
                password: {
                    value: this.props.form.getFieldValue("password"),
                    errors: [
                        {
                            field: "password",
                        },
                    ],
                },
            })
        }
    }

    onSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit(values.email, values.password)
            }
        })
    }
    formInputOnFocus = e => {
        e.target.select()
        this.props.form.setFields({
            [e.target.id]: {
                value: this.props.form.getFieldValue(e.target.id),
                errors: null,
            },
        })
    }

    toggleVisibility = () => {
        this.setState(prevState => ({
            isVisible: !prevState.isVisible,
        }))
    }

    render() {
        const { isVisible } = this.state

        const emailOptions = {
            validateTrigger: "onBlur",
            rules: [
                {
                    type: "email",
                    message: "Please enter valid email address",
                },
                {
                    required: true,
                    message: "Email address cannot be empty",
                },
            ],
        }
        const passwordOptions = {
            validateTrigger: "onBlur",
            rules: [
                {
                    required: true,
                    message: "Password cannot be empty",
                },
            ],
        }
        return (
            <div className="login-form">
                <Form onSubmit={this.onSubmit}>
                    <Form.Item className="big-form-item" hasFeedback={!!this.props.form.getFieldError("email")}>
                        {this.props.form.getFieldDecorator(
                            "email",
                            emailOptions
                        )(<Input placeholder="Email Address" onFocus={this.formInputOnFocus} autoComplete="email" />)}
                    </Form.Item>

                    <Form.Item className="big-form-item" hasFeedback={!!this.props.form.getFieldError("password")}>
                        {this.props.form.getFieldDecorator(
                            "password",
                            passwordOptions
                        )(
                            <Input
                                className="password"
                                type={isVisible ? "text" : "password"}
                                placeholder="Password"
                                onFocus={this.formInputOnFocus}
                                autoComplete="current-password"
                                suffix={
                                    isVisible ? (
                                        <EyeSlashFill
                                            onClick={this.toggleVisibility}
                                            className={"cursor-pointer text-gray-500"}
                                            title="Hide password"
                                            aria-label="Hide password"
                                        />
                                    ) : (
                                        <EyeFill
                                            onClick={this.toggleVisibility}
                                            className={"cursor-pointer text-gray-500"}
                                            title="Show password"
                                            aria-label="Show password"
                                        />
                                    )
                                }
                            />
                        )}
                    </Form.Item>

                    <Form.Item>
                        <Button
                            className="big-button"
                            type="primary"
                            htmlType="submit"
                            loading={this.props.isProcessing}>
                            Sign in
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        )
    }
}

export default Form.create()(LoginForm)
